// extracted by mini-css-extract-plugin
export default {"paused":"src-hellospa-components-cancellation-flow-modal-resume-paused-resume-paused-module__paused--2g8Cd"};